/* Trapezoid sector patch (rounded corners, sides converge along the fan's
   radial lines so the gaps between cards stay even) used as each feature
   card's outline. Shared by all cards: identical in the local, pre-rotation
   frame. Bottom/top width ratio (R-b)/(R+b) ≈ 0.9 matches the fan radius. */
export function HomeCardShape({ glow = false }: { glow?: boolean }) {
  return (
    <svg className={glow ? "ce-home-card-shape ce-home-card-shape--glow" : "ce-home-card-shape"} viewBox="0 0 126 114" preserveAspectRatio="none" aria-hidden="true">
      {/* Top-edge bulge must peak at y >= half the stroke width (0.6) and the bottom edge stay <= 114 - 0.6: the svg viewport clips content outside the viewBox, and the old control points (peak y=-0.6, bottom at exactly 114) made the outline fade out mid-edge ("描边渐变"). */}
      <path vectorEffect="non-scaling-stroke" d="M 13 2.2 Q 63 -0.7 113 2.2 Q 125 2.8 123.6 14 L 119 99 Q 117.8 112.6 104 113.2 Q 63 110.4 22 113.2 Q 8.2 112.6 7 99 L 2.4 14 Q 1 2.8 13 2.2 Z" />
    </svg>
  );
}
